import React from "react";
import { Send, MailOpen, Loader2 } from "lucide-react";
import Skeleton from "components/ui/Skeleton";

const TILE_STYLE = {
  primary: { bg: "bg-primary_tint", text: "text-primary", border: "border-primary/20" },
  success: { bg: "bg-success_bg", text: "text-success", border: "border-success_border" },
  warning: { bg: "bg-warning_bg", text: "text-warning", border: "border-warning_border" },
};

const StatTile = ({ icon: Icon, label, value, variant }) => {
  const s = TILE_STYLE[variant];
  return (
    <div className="flex-1 min-w-[200px] flex items-center gap-3 rounded-xl border border-border bg-surface p-4">
      <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border ${s.bg} ${s.border}`}>
        <Icon size={19} className={s.text} />
      </div>
      <div className="min-w-0">
        <div className="text-lg font-semibold text-text_primary tabular-nums">{value}</div>
        <div className="text-xs text-text_secondary truncate">{label}</div>
      </div>
    </div>
  );
};

const CampaignStatTiles = ({ stats, loading }) => {
  if (loading) {
    return (
      <div className="flex flex-wrap gap-4">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="flex-1 min-w-[200px] flex items-center gap-3 rounded-xl border border-border bg-surface p-4">
            <Skeleton className="h-11 w-11" rounded="rounded-xl" />
            <div className="flex-1 space-y-1.5">
              <Skeleton className="h-5 w-16" />
              <Skeleton className="h-3 w-24" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-4">
      <StatTile icon={Send} label="Total Mail Sent" value={(stats?.total_sent ?? 0).toLocaleString()} variant="primary" />
      <StatTile icon={MailOpen} label="Open Rate" value={`${stats?.open_rate ?? 0}%`} variant="success" />
      <StatTile icon={Loader2} label="Background Processing" value={stats?.background_processing ?? 0} variant="warning" />
    </div>
  );
};

export default CampaignStatTiles;
